var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cookie-button-component"},[_c('v-btn',{attrs:{"fab":"","elevation":"2","aria-label":"Manage cookie consent","ripple":false},on:{"click":_vm.onManageConsent}},[_c('v-icon',[_vm._v("fa-2x fa-solid fa-cookie-bite")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }